import { render, staticRenderFns } from "./recharge_order.vue?vue&type=template&id=5600a912&scoped=true"
import script from "./recharge_order.vue?vue&type=script&lang=js"
export * from "./recharge_order.vue?vue&type=script&lang=js"
import style0 from "./recharge_order.vue?vue&type=style&index=0&id=5600a912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5600a912",
  null
  
)

export default component.exports